// @ts-nocheck
import { useState, useEffect } from "react"
import { Navigate } from "react-router-dom"
import { supabaseClient } from "@/lib/supabase/client"
import { useAuth } from "@/components/layout/AuthProvider"
import { Avatar } from "@/components/ui/Avatar"

export default function MessagesPage() {
  const { supabaseUser } = useAuth()
  const [convos, setConvos] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!supabaseUser) return
    supabaseClient.from("messages")
      .select("*, sender:users!messages_sender_id_fkey(id,username,display_name,avatar_url), receiver:users!messages_receiver_id_fkey(id,username,display_name,avatar_url)")
      .or(`sender_id.eq.${supabaseUser.id},receiver_id.eq.${supabaseUser.id}`)
      .order("created_at", { ascending: false })
      .limit(50)
      .then(({ data }) => { setConvos(data || []); setLoading(false) })
  }, [supabaseUser?.id])

  if (!supabaseUser) return <Navigate to="/auth/login" replace />

  return (
    <div className="container-narrow py-4 pb-20 lg:pb-4">
      <h1 className="font-syne font-bold text-xl mb-4">Messages</h1>
      {loading ? (
        <div className="space-y-2">{[1,2,3].map(i => <div key={i} className="skeleton h-16 rounded" />)}</div>
      ) : convos.length === 0 ? (
        <div className="panel p-12 text-center">
          <p className="font-syne font-bold text-lg mb-1">No messages yet</p>
          <p className="text-sm text-muted-fg">Visit someone's profile to start a conversation.</p>
        </div>
      ) : (
        <div className="space-y-1">
          {convos.map((m: any) => {
            const other = m.sender?.id === supabaseUser.id ? m.receiver : m.sender
            return (
              <div key={m.id} className="panel p-3.5 flex items-center gap-3">
                <Avatar src={other?.avatar_url} alt={other?.display_name || "?"} size="sm" />
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-sm">u/{other?.username}</p>
                  <p className="text-xs text-muted-fg truncate">{m.content}</p>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
